'use strict';

angular.module('TurneroApp').component('coMisturnos', {
	bindings: {
		usuario: '<'
	},
	controller: [
		'$window',
		'turnosService',
		'TurneroAppConstant',
		'$rootScope',
		'motivosService',
		'angularGridInstance',
		'$scope',
		'$mdDialog',
		'$filter',
		'$localStorage',
		'utilsService',
		'tramiteService',
		  '$timeout',
		function ($window, turnosService, TurneroAppConstant, $rootScope, motivosService, angularGridInstance, $scope, $mdDialog, $filter, $localStorage, utilsService, tramiteService, $timeout) {
			var ctrl = this;
			ctrl.Estados_Turnos = TurneroAppConstant.Estados.Turno;
			$scope.angularGridoptions = {
				cssGrid: true,
				refreshOnImgLoad: true,
				gridWidth: 320 //minumum width of a grid, this may increase to take whole space of container
            }

            ctrl.TabProximo = "Mis turnos próximos";
            ctrl.TabAnteriores = "Mis turnos anteriores";

			ctrl._thisgrid;

			ctrl.query = {
				limit: 20,
				page: 1,
				filter: ''
			};

			//Se inicializa en null para que al principio no tome que no hay valores
			ctrl.pagination = {
                total: null,
                totalPages: null
			};


			ctrl.limpiarMemoria = function () {
				ctrl.turnosProximos = [];
				ctrl.turnosAnteriores = [];
				ctrl.turnosSeleccionados = [];
				$rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
			}

			ctrl.regresar = function ($event) {
				$rootScope.$broadcast('regresarDesdeMisTurnos');
			};

			ctrl.$onChanges = function () {
				ctrl.limpiarMemoria();
				ctrl.mostrarProximosTurnos();
			};

			ctrl.mostrarProximosTurnos = function () {
				ctrl.turnosAnteriores = null;
				ctrl._thisgrid = angularGridInstance.misturnos;
				utilsService.swalNotification('Cargando', 'Obteniendo tus próximos turnos', 'info');
				ctrl.limpiarMemoria();
				turnosService.Get_Proximos(function (resultado) {
					ctrl.turnosProximos = resultado.Data;
					if (ctrl.turnosProximos.length != 0) {
						for (var i = 0; i < ctrl.turnosProximos.length; i++) {
							ctrl.turnosSeleccionados[i] = false;
						}
					}

					swal.close();
                    ctrl.actualizarGrilla();
				}, function (error) {
					swal.close();
                    ctrl.actualizarGrilla();
				})

			};
			ctrl.paginationOptions = {
				currentPage: 1,
				itemsPerPage: 20,
				totalItems: 0,
				totalPages: 0
			};

			ctrl.seleccionarTurno = function (index, angularGrid) {

				if (ctrl.turnosSeleccionados[index] == undefined || ctrl.turnosSeleccionados[index] == null || ctrl.turnosSeleccionados[index] == false) {
					ctrl.turnosSeleccionados[index] = true;
				} else {
                    ctrl.turnosSeleccionados[index] = false;
				}

				if ('misturnosAnteriores' == angularGrid) {
					ctrl._thisgrid = angularGridInstance.misturnosAnteriores;
				} else if ('misturnos' == angularGrid) {
					ctrl._thisgrid = angularGridInstance.misturnos;
				} else {
					ctrl._thisgrid = angularGridInstance.misturnosHistorico;
				}

                ctrl.actualizarGrilla();
			}

			ctrl.mostrarTurnosAnteriores = function (desdeBoton) {
				ctrl.turnosProximos = null;
				ctrl._thisgrid = angularGridInstance.misturnosAnteriores;
				utilsService.swalNotification('Cargando', 'Obteniendo turnos anteriores', 'info');
                ctrl.limpiarMemoria();

                if (desdeBoton) {
                    ctrl.query.page = 1;
                }

				turnosService.Get_Anteriores({
					'filtro.Nro_Pagina': ctrl.query.page,
					'filtro.Tam_Pagina': ctrl.query.limit
				}).$promise.then(function (resultado) {
                    ctrl.pagination.total = resultado.Pagination.Reg_Totales;
                    ctrl.pagination.totalPages = Math.ceil(resultado.Pagination.Reg_Totales / ctrl.query.limit);
					ctrl.turnosAnteriores = resultado.Data;
					if (ctrl.turnosAnteriores.length != 0) {
						for (var i = 0; i < ctrl.turnosAnteriores.length; i++) {
							ctrl.turnosSeleccionados[i] = false;
						}
					}
					swal.close();
                    ctrl.actualizarGrilla();
				}).catch(function (error) {
					swal.close();
                    ctrl.actualizarGrilla();
				})
			};

			ctrl.openCancelarEx = function () {
				ctrl.cerrarModal()
				window.open(ctrl.modalTurno.Url_Cancelacion, '_blank');

			}
			ctrl.cancelarTurnos = function (turno) {
				if (turno.Mensaje_Cancelacion) {
					ctrl.modalTurno = turno;
					$mdDialog.show({
						template: require('./modalCancelarTurno.html'),
						parent: angular.element(document.body),
						clickOutsideToClose: false,
						fullscreen: false, // Only for -xs, -sm breakpoints.,
						controllerAs: '$ctrl',
						controller: function () {
							return ctrl;
						}
					});
				} else {
                    motivosService.GetByTipoMotivo({ 'id_tipo_motivo': TurneroAppConstant.TipoMotivos.Cancelacion_Ciudadano }, function (data) {
						var opciones = [];
						var combo = '';
						if (data.length > 0) {
							for (var i = 0; i < data.length; i++) {
								var Indice = 0;
								var valor = '';
								var array = [];
								angular.forEach(data[i], function (value, key) {
									if (key == 'id') {
										Indice = value;
									}
									if (key == 'text') {
										valor = value
									}
								});
								opciones[Indice] = valor;
							}
						}


						swal({
							title: 'Cancelar turno',
							html: "¿Confirma que desea cancelar el turno del día <strong> " + $filter('date')(turno.Fec_Turno, 'dd/MM/yyyy') + "</strong> a las <strong>" + turno.Hora_Desde + " </strong>? <br/> Si es así, indíquenos el motivo de la cancelación:",
							type: 'warning',
							input: 'select',
							showCancelButton: true,
							inputOptions: opciones,
							confirmButtonColor: '#3085d6',
							cancelButtonColor: '#d33',
							confirmButtonText: 'Aceptar'
						}).then(function (input) {
							turno.id_motivo = input;
							utilsService.swalTitle('Cancelando turno.', 'info');
							turnosService.Put_Turno_Cancelar({ 'id_turnos': turno.Id_Turno, 'id_motivo': turno.id_motivo }, function () {
								swal.close();
								ctrl.mostrarProximosTurnos();
								swal(
								  'Turno cancelado!',
								  'El turno ha sido cancelado correctamente.',
								  'success'
								)

							}, function (error) {
								swal.close();
								utilsService.errores(error);
							});
						}
				  );
					});
				};
			};

			ctrl.ImprimirComprobante = function (Id_Turno) {
				ctrl.turnoSeleccionado = null;
				$window.open('#!/reimprimir?Id_Turno=' + Id_Turno, '_blank');
				ctrl.cerrarModal()
			};
			ctrl.cerrarModal = function () {
				ctrl.turnoSeleccionado = null;
				$mdDialog.destroy();
			};

            ctrl.showMapa = function (Domicilio) {
                $window.open('https://www.google.com/maps/search/?api=1&query=' + Domicilio, '_blank');			
			};

			ctrl.detallesTramite = function (turno) {
				ctrl.turnoSeleccionado = turno;
				tramiteService.Get_Tramite_Detalle({ 'id_tramite': ctrl.turnoSeleccionado.Id_Tramite_Relevado, 'muestra_cdd': ctrl.turnoSeleccionado.Muestra_CDD }, function (resultado) {
					ctrl.turnoSeleccionado.Tramite = resultado.Data.Tramite;
				})
				$mdDialog.show({
					template: require('./modalDetalleTramite.html'),
					parent: angular.element(document.body),
					clickOutsideToClose: false,
					fullscreen: false, // Only for -xs, -sm breakpoints.,
					controllerAs: '$ctrl',
					controller: function () {
						return ctrl;
					}
				});
			}

			ctrl.reimprimirTurno = function (turno) {
				ctrl.turnoSeleccionado = turno;
				ctrl.turnoSeleccionado.usuario = {
					nombre: $localStorage.TurneroApp_Authorization.usuario.nombre,
					CUIT: utilsService.CUIL_Formateado($localStorage.TurneroApp_Authorization.usuario.CUIL)
				};
				$mdDialog.show({
					template: require('./modalComprobante.html'),
					parent: angular.element(document.body),
					clickOutsideToClose: false,
					fullscreen: false, // Only for -xs, -sm breakpoints.,
					controllerAs: '$ctrl',
					controller: function () {
						return ctrl;
					}
				});
			};

			ctrl.mostrarHistoricoTurnos = function () {
				ctrl.mostrarHistorico = !ctrl.mostrarHistorico
				if (ctrl.mostrarHistorico) {
					utilsService.swalNotification('Cargando', 'Obteniendo historial de turnos', 'info');
					turnosService.Get_Anteriores_Hist().$promise.then(function (resultado) {
						ctrl.turnosHistAnteriores = resultado.Data;
						if (ctrl.turnosHistAnteriores.length != 0) {
							for (var i = 0; i < ctrl.turnosHistAnteriores.length; i++) {
								ctrl.turnosSeleccionados[i] = false;
							}
						}
						swal.close();
					}).catch(function (error) {
						swal.close();
					})
				}
            }

            ctrl.DetectedPantalla = function () {

                if (screen.width < 1024) {
                    ctrl.TabProximo = "Próximo";
                    ctrl.TabAnteriores = "Anteriores";
                } else {
                    ctrl.TabProximo = "Mis turnos próximos";
                    ctrl.TabAnteriores = "Mis turnos anteriores";
                }
            };

            window.onresize = function () {
                ctrl.DetectedPantalla();
            }

            ctrl.DetectedPantalla();

            ctrl.actualizarGrilla = function () {
				$timeout(function () {
					if (!ctrl._thisgrid) {
						ctrl._thisgrid = angularGridInstance.misturnos;
					}
                    ctrl._thisgrid.refresh();
				}, 1500);
			}

		}],
	template: require('./misTurnos.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/misTurnosComponent.js